// A saved Input.Time answer reaches the activity log as the adaptive card TIME token: the stored answer is an
// instant and keeps no offset, so only the browser knows which wall clock to show for it.
//
// The clock formatting is written out here rather than reusing formatTimeInput / renderTimeInputInRequest
// because both live in component files that drag in adaptivecards-designer and monaco-editor, which no test in
// this repo can import.
const timeTokenPattern = /^\{\{TIME\((.+)\)\}\}$/;

const localWallClock = (instant: string) => {
  const localTime = new Date(instant);
  if (isNaN(localTime.getTime())) return null;

  const hour = localTime.getHours();
  const minute = `0${localTime.getMinutes()}`.slice(-2);

  return `${hour % 12 || 12}:${minute} ${hour < 12 ? 'AM' : 'PM'}`;
};

export const renderCustomFormAnswer = (answer: string) => {
  const timeToken = timeTokenPattern.exec(answer ?? '');
  if (!timeToken) return answer;

  return localWallClock(timeToken[1]) ?? answer;
};
